import { EAnalyticMode } from '~/modules/analytics/types';
import { GViewBySelector } from '~/presentation/common';
import { useTranslation } from 'react-i18next';

import IMAGE_FIRST_SESSION from '~/modules/analytics/assets/img/first-session.png';
import IMAGE_ALL_SESSION from '~/modules/analytics/assets/img/all-sessions.png';

const VIEW_BY_OPTIONS = [
  {
    id: EAnalyticMode.ALL_SESSION,
    content: 'All sessions',
    helpText:
      'Count metrics for every experiment session where the Control or Variant shows up anywhere in the user’s journey: before, during, or after other pages.',
    icon: IMAGE_ALL_SESSION,
  },
  {
    id: EAnalyticMode.FIRST_SESSION,
    content: 'Entry session only',
    helpText:
      'Count metrics for experiment sessions only where users began their visit on the Control or Variant page, then track how they moved through the funnel for that version.',
    icon: IMAGE_FIRST_SESSION,
  },
  // {
  //   id: EAnalyticMode.PAGE_ONLY,
  //   content: 'Control & Variant only',
  //   helpText:
  //     'Count metrics from Control or Variant page that lead directly to checkout, using data from all sessions that visited it.',
  //   icon: IMAGE_PAGE_ONLY,
  // },
];

export interface TrackingSelectorProps {
  analyticMode: EAnalyticMode;
  handleSetAnalyticMode: (mode: EAnalyticMode) => void;
  activatorText?: string;
}

export const TrackingSelector: React.FC<TrackingSelectorProps> = ({
  analyticMode,
  handleSetAnalyticMode,
  activatorText,
}) => {
  const { t } = useTranslation();

  const handleSelect = (value: string) => {
    handleSetAnalyticMode(value as EAnalyticMode);
  };

  return (
    <GViewBySelector
      activatorText={activatorText ?? t('View by')}
      options={VIEW_BY_OPTIONS}
      selected={analyticMode}
      onSelect={handleSelect}
      maxWidth="650px"
    />
  );
};
